(() => {
  const dialog = document.getElementById('W99FirstOrderOffer');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const storageKey = 'w99-first-order-dismissed-' + dialog.dataset.country + '-' + dialog.dataset.member + '-' + dialog.dataset.eligible;
  const dismissalDays = 30;
  let dismissedAt = 0;
  try { dismissedAt = Number(localStorage.getItem(storageKey)) || 0; } catch (_) {}
  if (Date.now() - dismissedAt < dismissalDays * 86400000) return;
  const remember = () => {
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (_) {}
  };
  dialog.addEventListener('close', remember);
  dialog.querySelector('[data-offer-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  const copyButton = dialog.querySelector('[data-offer-copy]');
  if (copyButton) copyButton.addEventListener('click', async () => {
    const code = dialog.querySelector('#W99OfferCode');
    try {
      await navigator.clipboard.writeText(code.value);
      dialog.querySelector('[role="status"]').textContent = dialog.dataset.copied;
    } catch (_) {
      code.focus();
      code.select();
    }
  });
  dialog.querySelector('.w99-first-offer__shop').addEventListener('click', remember);
  setTimeout(() => {
    if ([...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(el => {
      const rect = el.getBoundingClientRect();
      const visible = typeof el.checkVisibility === 'function' ? el.checkVisibility({checkOpacity:true, checkVisibilityCSS:true}) : getComputedStyle(el).visibility !== 'hidden';
      return visible && rect.width > 20 && rect.height > 20;
    })) return;
    dialog.showModal();
  }, 12000);
})();
